import { Slider as SliderCore, SliderItem, SliderProgress } from '@studiometa/ui';
import SliderDrag from './SliderDrag.js';

export default class Slider extends SliderCore {
  static config = {
    name: 'Slider',
    components: {
      SliderDrag,
      SliderItem,
      SliderProgress,
    },
  };
}
